import React from 'react'
import { withTranslation } from 'react-i18next';
import Google from '../../images/google.svg';
import Facebook from '../../images/facebook.svg';
import Parent from '../../common/parent';
import { constants } from "../../common/constants/constants";

class SignUp extends Parent{

    renderTitle(){
        const {t} = this.props;

        return (
            <section>
                <div className="container">
                    <div className="row">
                        <div className="sign_sec col-md-12">
                            <h2 className="text-center">{t('signup.open_a_new_user')}</h2>
                            <p>{t('signup.open_a_new_user_sub_title')}</p>
                            <span>{t('signup.open_a_new_user_with')}:</span>
                        </div>
                        <div className="sign_social_icon col-md-12 ">
                            <div className="col-sm-6 sign_in_right">
                                <a href="/" social-name="Google"  className="sign_social_2">
                                    <img alt='google connect' src={Google}/>{t('login.google')}
                                </a>
                            </div>
                            <div className="col-sm-6 sign_in_left">
                                <a href="/" social-name="Facebook"  className="sign_social_1">
                                    <img alt='facebook connect' src={Facebook}/>{t('login.facebook')}
                                </a>
                            </div>
                        </div>
                        <div className=" col-md-12 col-sm-12">
                            <p className="or">{t('signup.or_with')}</p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
    render() {
        const {t} = this.props;
        this.setBodyClasses(constants.backgroundOptions.signup);

        return (
            <div>
                {this.renderTitle()}
                <section>
                    <div className="container">
                        <div className="col-md-12">
                            <div className="inner-sign-up">
                                <form>
                                    <div className="row">
                                        <div className="sign_up_from">
                                            <div className="sign_form_1">
                                                <div className="form-group">
                                                    <label htmlFor="first-name">{t('signup.first_name')}: *</label>
                                                    <input type="text" className="form-control" name="first-name"
                                                           id="first-name"/>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="last-name">{t('signup.last_name')}: * </label>
                                                    <input type="text" className="form-control" name="last-name"
                                                           id="last-name"/>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="phone">{t('signup.phone')}: * </label>
                                                    <input type="text" className="form-control" name="phone" id="phone"/>
                                                </div>
                                            </div>
                                            <div className="sign_form_2">
                                                <div className="form-group">
                                                    <label htmlFor="Email">{t('signup.email')}: * </label>
                                                    <input type="email" className="form-control" name="email"
                                                           id="email"/>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="password">{t('signup.password')}: * </label>
                                                    <input type="password" className="form-control" name="password"
                                                           id="password"
                                                           />
                                                </div>
                                            </div>
                                            <div className="sign_form_2">
                                                <div className="form-group">
                                                    <label htmlFor="email-confirmation">{t('signup.email_verify')}: * </label>
                                                    <input type="email" className="form-control"
                                                           name="email-confirmation" id="email-confirmation"/>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="Confirm-Password">{t('signup.password_verify')}: * </label>
                                                    <input type="password" className="form-control"
                                                           name="confirm-password" id="confirm-password"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sign_btn_in">
                                        <div className="form-group">
                                            <input type="submit" name="sign-in" id="sign-in" value={t('buildings.confirm')}/>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default withTranslation()(SignUp)
